import { useState, useEffect } from 'react';
import { trendService } from '@/services/trend';
import { Trend } from '@/types/trend';

export const useTrends = () => {
  const [trends, setTrends] = useState<Trend[]>([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchTrends = async () => {
      try {
        const response = await trendService.getAll();
        
        if (Array.isArray(response)) {
          setTrends(response);
          setTotal(response.length);
        } else {
          
          setTrends(response.data || []);
          setTotal(response.total || 0);
        }
      } catch {
        setError('Failed to load trends');
      } finally {
        setLoading(false);
      }
    };

    fetchTrends();
  }, []);

  return { trends, total, loading, error };
};
